import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom, MAX_ANIMATION_TIMEOUT } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { cookieHeaderName, csrfTokenName } from './common/constants.lib';
import { casiXsrfInterceptor } from './interceptors/casi-xsrf.interceptor';
import { bearerRefreshInterceptor } from './interceptors/bearer-refresh.interceptor';
import { cookieInterceptor } from './interceptors/cookie.interceptor';
import { spinnerInterceptor } from './interceptors/spinner.interceptor';
import { provideToastr } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { loggingInterceptor } from './interceptors/logging-interceptor';
import { cachingInterceptor } from './interceptors/caching-interceptor';
import { refresherInterceptor } from './interceptors/refresher-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: cookieHeaderName, // 'X-CSRF-TOKEN',
        headerName: csrfTokenName // 'X-CSRF-TOKEN'
      }),
      // withInterceptors([casiXsrfInterceptor, bearerInterceptor, cookieInterceptor])
      // withInterceptors([httpInterceptor])
      // withInterceptors([bearerRefreshInterceptor, bearerInterceptor, cookieInterceptor])
      // withInterceptors([bearerInterceptor, cookieInterceptor])
      withInterceptors([casiXsrfInterceptor, refresherInterceptor, // bearerRefreshInterceptor,
        cookieInterceptor, spinnerInterceptor, cachingInterceptor, loggingInterceptor])
      // withInterceptors([bearerRefreshInterceptor, cookieInterceptor])
    ),
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-top-center',
      preventDuplicates: true
    }),
    CookieService,
    // provideAnimationsAsync(),
    // importProvidersFrom(
    //   BrowserModule,
    //   AppRoutingModule,
    //   RouterModule,
    //   LoadingIndicatorService
    // ), {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: loadingInterceptor,
    //   multi: true
    // }
    // {
    //   provide: ICON_SETTINGS,
    //   useValue: {
    //     type: "font"
    //   }
    // },
    importProvidersFrom([BrowserAnimationsModule]),
    { provide: MAX_ANIMATION_TIMEOUT, useValue: 6000 }

  ],
};

